import React from "react";

export default function PlayerPhoto({ photo }) {
  return (
    <div className="text-center m-auto text-sm-start photo-section ">
      <img src={photo} alt="profile" className=" rounded img-fluid " />
    </div>
  );
}
